<template>
  <div>
    <v-dialog v-model="dialog.dialogBrowseCustomer" max-width="800px" scrollable eager>
      <CustomerJobBrowse ref="CustomerJobBrowse"
        :receiveVar="sendVar" @eventReturn="getVarReturn">
      </CustomerJobBrowse>
    </v-dialog>
    <v-dialog v-model="dialog.dialogBrowseProject" max-width="800px" scrollable eager>
      <ProjectBrowse ref="ProjectBrowse"
        :receiveVar="sendVar" @eventReturn="getVarReturn">
      </ProjectBrowse>
    </v-dialog>
    <v-dialog v-model="dialog.dialogBrowseJob" max-width="800px" scrollable eager>
      <JobBrowse ref="JobBrowse"
        :receiveVar="sendVar" @eventReturn="getVarReturn">
      </JobBrowse>
    </v-dialog>
    <v-dialog v-model="dialog.dialogBrowsePersonInCharge" max-width="800px" scrollable eager>
      <CustomerIssueLogUserBrowse ref="CustomerIssueLogUserBrowse"
        :receiveVar="sendVar" @eventReturn="getVarReturn">
      </CustomerIssueLogUserBrowse>
    </v-dialog>
    <v-dialog v-model="dialog.dialogBrowseAssigner" max-width="800px" scrollable eager>
      <CustomerIssueLogUserBrowse ref="AssignerBrowse"
        :receiveVar="sendVar" @eventReturn="getVarReturn">
      </CustomerIssueLogUserBrowse>
    </v-dialog>
    <v-dialog v-model="dialog.dialogBrowseIssueLogID" max-width="800px" scrollable eager>
      <IssueLogIDBrowse ref="IssueLogIDBrowse"
        :receiveVar="sendVar" @eventReturn="getVarReturn">
      </IssueLogIDBrowse>
    </v-dialog>
    <v-dialog v-model="dialog.dialogBrowseResultItem" max-width="800px" scrollable eager>
      <ResultItemBrowse ref="ResultItemBrowse"
        :receiveVar="sendVar" @eventReturn="getVarReturn">
      </ResultItemBrowse>
    </v-dialog>
    <v-toolbar scrollable color="light-blue darken-4" dark>
      <v-spacer></v-spacer>
      <v-btn ref = "buttonNew" color="primary" style="text-transform: capitalize" @click="newJob" :disabled="disabledControl.buttonNew">
        <img src="../assets/SoftwareClinicIcon/New.png" height="30" weight="30"/>{{$t('new')}}
      </v-btn>
      <v-btn ref = "buttonDelete" color="primary" style="text-transform: capitalize" @click="deleteJob" :disabled="disabledControl.buttonDelete">
        <img src="../assets/SoftwareClinicIcon/Delete.png" height="30" weight="30"/>{{$t('delete')}}
      </v-btn>
      <v-btn ref = "buttonSave" color="primary" style="text-transform: capitalize" @click="saveJob" :disabled="disabledControl.buttonSave">
        <img src="../assets/SoftwareClinicIcon/Save.png" height="30" weight="30"/>{{$t('save')}}
      </v-btn>
      <v-btn ref = "buttonQuery" color="primary" style="text-transform: capitalize" @click="queryJob" :disabled="disabledControl.buttonQuery">
        <img src="../assets/SoftwareClinicIcon/Query.png" height="30" weight="30"/>{{$t('query')}}
      </v-btn>
      <v-btn ref = "buttonFind" color="primary" style="text-transform: capitalize" @click="findResultItem" :disabled="disabledControl.buttonFind">
        <img src="../assets/SoftwareClinicIcon/Find.png" height="30" weight="30"/>{{$t('find')}}
      </v-btn>
    </v-toolbar>
    <v-container grid-list-xs text-xs-center fluid>
          <v-row row wrap>
            <v-col cols="12" xs="12" md="3" class="pt-2 pb-1 mb-1">
              <v-text-field label="Result Item ID" v-model="resultItemData.result_item_id" ref="textFieldResultItemID" :readonly="readOnlyControl.textFieldResultItemID" outlined dense hide-details></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" md="3" class="pt-2 pb-1 mb-1">
              <v-text-field label="Result Item Description" v-model="resultItemData.result_item_desc" outlined dense hide-details></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="3">
              <v-menu v-model="menu.menuEffectiveStartDate" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field dense hide-details outlined v-model="resultItemData.eff_start_date" label="Effective Start Date" append-outer-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="resultItemData.eff_start_date" @input="menu.menuEffectiveStartDate = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="12" md="3">
              <v-menu v-model="menu.menuEffectiveStopDate" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field dense hide-details outlined v-model="resultItemData.eff_stop_date" label="Effective Stop Date" append-outer-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="resultItemData.eff_stop_date" @input="menu.menuEffectiveStopDate = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row row wrap>
            <v-col cols="12" xs="12" md="3" class="pt-2 pb-1 mb-1">
              <v-text-field label="Result Item Alias ID" v-model="resultItemData.alias_id" outlined dense hide-details></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" md="3" class="pt-2 pb-1 mb-1">
              <v-text-field label="Result Item Alias Descrpition" v-model="resultItemData.alias_desc" outlined dense hide-details></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" md="3" class="pt-2 pb-1 mb-1">
              <v-text-field label="nickname" v-model="resultItemData.nickname" outlined dense hide-details></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="3">
              <v-select :items="dropDownData.lis_uom" v-model="resultItemData.uom" item-text="uom_desc" item-value="uom" label="UOM" @change="changeLocation($event)" persistent-hint single-line outlined dense hide-details>
              </v-select>
            </v-col>
          </v-row>
          <v-row row wrap>
            <v-col cols="12" xs="12" md="3" class="pt-2 pb-1 mb-1">
              <v-text-field label="Additional Descrpition" v-model="resultItemData.additional_desc" outlined dense hide-details></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="3">
              <v-select :items="dropDownData.lis_r_result_type" v-model="resultItemData.result_type" item-text="result_type_desc" item-value="result_type_cd" label="Result Type" @change="changeLocation($event)" persistent-hint single-line outlined dense hide-details>
              </v-select>
            </v-col>
            <v-col cols="12" sm="12" md="2">
              <v-text-field label="Decimal Digit" v-model="resultItemData.decimal_digit" type="number" outlined dense hide-details>></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="3">
              <v-checkbox v-model="resultItemData.active" label="Active" hide-details>
              </v-checkbox>
            </v-col>
          </v-row>
          <v-row row wrap>
            <v-col cols="12" xs="12" md="6" class="pt-2 pb-1 mb-1">
              <v-textarea
                v-model="resultItemData.remark"
                outlined hide-details
                color="black"
                label="Remark"
                ></v-textarea>
            </v-col>
            <!-- <v-col cols="12" xs="12" md="3" class="pt-2 pb-1 mb-1">
              <v-text-field label="Result Form" v-model="resultItemData.result_form_skey"
                outlined dense hide-details readonly
                @click:clear="clearAssigner"
                clearable>
                <template v-slot:append>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on" color="blue" @click="browseAssigner">mdi-file-find</v-icon>
                    </template>
                    Search Person In Charge
                  </v-tooltip>
                </template>
              </v-text-field>
            </v-col> -->
            <v-col cols="12" sm="12" md="3">
              <v-select :items="dropDownData.lis_result_item_calc_type" v-model="resultItemData.calc_type_cd" item-text="calc_type_desc" item-value="calc_type_cd" label="Calc Type" @change="changeLocation($event)" persistent-hint single-line outlined dense hide-details>
              </v-select>
            </v-col>
          </v-row>
          <v-row row wrap>
            <v-col cols="12" sm="12" md="2">
              <v-text-field label="Delta Unit" v-model="resultItemData.delta_unit" type="number" outlined dense hide-details>></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="2">
              <v-text-field label="Delta Percent" v-model="resultItemData.delta_pct" type="number" outlined dense hide-details>></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="2">
              <v-text-field label="Delta Time Interval" v-model="resultItemData.delta_time_interval" type="number" outlined dense hide-details>></v-text-field>
            </v-col>
          </v-row>
          <v-row row wrap>
            <v-col cols="12" xs="12" md="12" class="pt-2 pb-1 mb-1">
              <v-text-field label="Function" v-model="resultItemData.function_value" outlined dense hide-details></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" md="12" class="pt-2 pb-1 mb-1">
              <v-text-field label="Method" v-model="resultItemData.result_method" outlined dense hide-details></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" md="12" class="pt-2 pb-1 mb-1">
              <v-text-field label="Formula" v-model="resultItemData.formula" outlined dense hide-details></v-text-field>
            </v-col>
          </v-row>
    </v-container> 
    <!-- <v-tabs v-model="activeTab">
        <v-tab v-for="tab in resultItemData.lis_result_item_attr_text" :key="tab.result_item_attr_skey" :value="tab.result_item_attr_skey">
          {{ tab.attr_text }}
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="activeTab">
        <v-tab-item v-for="tab in resultItemData.lis_result_item_attr_text" :key="tab.result_item_attr_skey" :value="tab.result_item_attr_skey">
          <v-card flat>
            <v-card-text>{{ tab.attr_text }}</v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>  -->
      <v-tabs v-model="tab" background-color="primary" dark>
      <v-tab
        v-for="(item, index) in resultItemData.lis_result_item_attr_text"
        :key="index"
      >
        {{ item.attr_text }}
      </v-tab>
    </v-tabs>
    <!-- Tab Items -->
    <v-tabs-items v-model="tab">
      <v-tab-item
        v-for="(attr_text, index) in resultItemData.lis_result_item_attr_text"
        :key="index">
        <v-card flat>
          <v-card-text>
            {{ attr_text.attr_text }}
            {{ index }}
          </v-card-text>
        </v-card>
        <v-data-table
          v-model="attr_text.selected_result_item_attr"
          :headers="headersAttribute"
          :items="attr_text.lis_result_item_attr"
          :search="attr_text.search_result_item_attr"
          show-select
          fixed-header
          :page.sync="vDataTable.options.page"
          :itemsPerPage.sync="vDataTable.options.itemsPerPage"
          :options.sync="vDataTable.options"
          :height="300"
          :footer-props="{
            itemsPerPageText: $t('itemsPerPageText'),
            itemsPerPageAllText: $t('itemsPerPageAllText'),
            showFirstLastPage: true,
            showCurrentPage: true,
            firstIcon: 'mdi-arrow-collapse-left',
            lastIcon: 'mdi-arrow-collapse-right',
            prevIcon: 'mdi-minus',
            nextIcon: 'mdi-plus',
          }"
          item-key="attr_dtl_skey"
          class="fill-height">
          <template v-slot:header.win_name="{ header }">
              {{ header.text.toUpperCase() }}
          </template>
          <template v-slot:header.data-table-select="{ on, props }">
            <tr>
              <td>
                <v-simple-checkbox :ripple="false" v-bind="props" v-on="on"></v-simple-checkbox>
              </td>
              <td v-if="vDataTable.selected.length > 0">
                {{vDataTable.selected.length}}
              </td>
            </tr>
          </template>
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>{{ index }}</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <!-- <v-dialog v-model="dialog.dialogAddEdit" max-width="1000px" eager>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn outlined color="primary" v-bind="attrs" v-on="on" style="text-transform: capitalize" @click="newJobDetail()">
                    <img src="../assets/SoftwareClinicIcon/New.png" height="30" weight="30"/>New
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="12" md="3">
                          <v-menu v-model="menu.menuStartDate" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field dense hide-details outlined v-model="vDataTable.editedItem.start_date" label="Start Date" append-outer-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker v-model="vDataTable.editedItem.start_date" @input="menu.menuStartDate = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="12" sm="12" md="3">
                          <v-menu v-model="menu.menuDueDate" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field dense hide-details outlined v-model="vDataTable.editedItem.due_date" label="Due Date" append-outer-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker v-model="vDataTable.editedItem.due_date" @input="menu.menuDueDate = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="12" xs="12" md="3">
                          <v-select :items="dropDownData.job_detail_status" v-model="vDataTable.editedItem.status" item-text="description" item-value="code" label="Status" @change="changeStatus($event)" persistent-hint outlined dense hide-details>
                          </v-select>
                        </v-col>
                        <v-col cols="12" sm="12" md="3">
                          <v-menu v-model="menu.menuCompleteDate" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field dense hide-details outlined v-model="vDataTable.editedItem.complete_date" label="Complete Date" append-outer-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker v-model="vDataTable.editedItem.complete_date" @input="menu.menuCompleteDate = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" xs="12" md="9">
                          <v-textarea
                              outlined hide-details
                              color="black"
                              label="Remark"
                              v-model="vDataTable.editedItem.remark"
                            ></v-textarea>
                        </v-col>
                        <v-col cols="12" xs="12" md="3">
                          <v-text-field label="% Progress" v-model="vDataTable.editedItem.pct_progress" type="number" outlined dense hide-details single-line></v-text-field>
                        </v-col> 
                      </v-row>
                      <v-row>
                        <v-col cols="12" xs="12" md="3">
                          <v-select :items="dropDownData.postpone_type" v-model="vDataTable.editedItem.postpone_type" item-text="description" item-value="code" label="PostPone Type" @change="changePostponeType($event)" persistent-hint outlined dense hide-details>
                          </v-select>
                        </v-col>
                        <v-col cols="12" xs="12" md="9">
                          <v-text-field label="Postpone Remark" v-model="vDataTable.editedItem.postpone_remark" outlined dense hide-details></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" xs="12" md="3">
                          <v-text-field label="Create User" v-model="vDataTable.editedItem.user_created" outlined dense hide-details readonly></v-text-field>
                        </v-col>
                        <v-col cols="12" xs="12" md="9">
                          <v-text-field label="Create Date" v-model="vDataTable.editedItem.date_created" outlined dense hide-details readonly></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" xs="12" md="3">
                          <v-text-field label="Change User" v-model="vDataTable.editedItem.user_changed" outlined dense hide-details readonly></v-text-field>
                        </v-col>
                        <v-col cols="12" xs="12" md="9">
                          <v-text-field label="Change Date" v-model="vDataTable.editedItem.date_changed" outlined dense hide-details readonly></v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                      <v-btn outlined color="primary" @click="close">{{$t('cancel')}}</v-btn>
                      <v-btn outlined color="primary" @click="save" :disabled="disabledControl.buttonSaveDetail">{{$t('save')}}</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-divider class="mx-1" inset vertical></v-divider>
              <v-btn outlined color="primary" @click="checkDeleteselected" style="text-transform: capitalize">
                <img src="../assets/SoftwareClinicIcon/Delete.png" height="30" weight="30"/>Detail
              </v-btn> -->
              <v-divider class="mx-1" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <v-text-field v-model="attr_text.search_result_item_attr" append-icon="mdi-magnify" :label="$t('search')"></v-text-field>
            </v-toolbar>
          </template>
          <!-- eslint-disable-next-line -->
          <template v-slot:item.data-table-select="{ isSelected, select }">
            <v-simple-checkbox :value="isSelected" :ripple="false" @input="select($event)" ></v-simple-checkbox>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="teal" small class="mr-2" v-bind="attrs" v-on="on" @click="editItem(item)">edit</v-icon>
              </template>
              <span>Edit</span>
            </v-tooltip>
            <!-- <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="pink" small class="mr-2" v-bind="attrs" v-on="on" @click="deleteItemConfirm(item)">delete</v-icon>
              </template>
              <span>Delete</span>
            </v-tooltip> -->
          </template>
          <template v-slot:item.data-table-no="{ item, index }">
            {{((vDataTable.options.page - 1) * vDataTable.options.itemsPerPage) + index + 1}}
          </template>
          <template v-slot:no-data>
            <v-alert type="info">
              {{$t('noData')}}
            </v-alert>
          </template>
          <template v-slot:no-results>
            <v-alert type="warning">
              {{stringFormat($t('searchNotFound'),attr_text.search_result_item_attr)}}
            </v-alert>
          </template>
          <template v-slot:footer>
            <tr class="sticky-table-footer" style="position: absolute">
              <td>Selected({{vDataTable.selected.length}})s</td> 
            </tr>
          </template>
        </v-data-table>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>
<script>
import { mapMutations, mapGetters, mapState } from 'vuex'
import CustomerJobBrowse from '@/components/common/CustomerJobBrowse'
import CustomerIssueLogUserBrowse from '@/components/common/CustomerIssueLogUserBrowse'
import ProjectBrowse from '@/components/common/ProjectBrowse'
import JobBrowse from '@/components/common/JobBrowse'
import IssueLogIDBrowse from '@/components/common/IssueLogIDBrowse'
import ResultItemBrowse from '@/components/common/ResultItemBrowse'

export default {
  components: {
    CustomerJobBrowse,
    CustomerIssueLogUserBrowse,
    ProjectBrowse,
    JobBrowse,
    IssueLogIDBrowse,
    ResultItemBrowse,
  },

  props: ['parentComponent'],

  data () {
    return {
      utils: require('@/utils'),
      stringFormat: require('string-format'),
      appName: process.env.VUE_APP_DB_APP_NAME,
      dialog: {
        dialogProgress: false,
        dialogAddEdit: false,
        dialogCriteria: false,
        dialogBrowseCustomer: false,
        dialogBrowseProject: false,
        dialogBrowseJob: false,
        dialogBrowsePersonInCharge: false,
        dialogBrowseAssigner: false,
        dialogBrowseIssueLogID: false,
        dialogBrowseResultItem: false,
      },
      stateWindow: '',
      readOnlyControl: {
        textFieldResultItemID: false,
      },
      disabledControl: {
        buttonNew: false,
        buttonDelete: false,
        buttonSave: false,
        buttonQuery: false,
        buttonFind: false,
        buttonSaveDetail: false,
      },
      menu: {
        menuStartDate: false,
        menuDueDate: false,
        menuCompleteDate: false,
        menuEffectiveStartDate: false,
        menuEffectiveStopDate: false,
      },
      jobData: [],
      resultItemData: [],
      vDataTable: {
        search: '',
        selected: [],
        data: [],
        editedIndex: -1,
        editedItem: {
          win_name: '',
          window_comment: ''
        },
        defaultItem: {
          win_name: '',
          window_comment: ''
        },
        options: {
          page: 1,
          itemsPerPage: 10,
          sortBy: [],
          sortDesc: [],
          groupBy: [],
          groupDesc: true,
          multiSort: true,
          // mustSort: true
        },
      },
      sendVar: [],
      dropDownData: [],
      progressMessage: '',
      criteria: {
        requestDateFromTo: [],
        createdDateFromTo: [],
        status: '',
        custSkey: -1,
        custName: '',
        personInCharge: '',
        personInChargeName: '',
      },
      activeTab: 0,
      tab: 0,
    }
  },

  computed: {
    ...mapGetters(['getShowAppBar', 'getAppBarHeight']),
    ...mapState({
      userID: state => `${state.user.profile.user_id}`,
      userFullName: state => `${state.user.profile.user_fullname}`,
    }),
    dateRangeTextRequestDateFromTo () {
      return this.criteria.requestDateFromTo.join(' ~ ')
    },
    dateRangeTextCreatedDateFromTo () {
      return this.criteria.createdDateFromTo.join(' ~ ')
    },
    formTitle () {
      return this.vDataTable.editedIndex === -1 ? 'New Job Detail' : 'Edit Job Detail'
    },
    headers () {
      return [
        { text: '#', align: 'center', value: 'data-table-no', class: 'text-xl-left body-1 black--text' },
        { text: '', align: 'center', value: 'data-table-select', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('actions'), value: 'actions', sortable: false, class: 'text-xl-left body-1 black--text' },
        { text: 'job_detail_skey', align: 'left', value: 'job_detail_skey', class: 'text-xl-left body-1 black--text' },
        { text: 'job_id', align: 'left', value: 'job_id', class: 'text-xl-left body-1 black--text' },
        { text: 'start_date', width: '200', align: 'left', value: 'start_date', class: 'text-xl-left body-1 black--text' },
        { text: 'due_date', align: 'left', value: 'due_date', class: 'text-xl-left body-1 black--text' },
        { text: 'status', align: 'left', value: 'status', class: 'text-xl-left body-1 black--text' },
        { text: 'complete_date', align: 'left', value: 'complete_date', class: 'text-xl-left body-1 black--text' },
        { text: 'Postpone Type', align: 'left', value: 'postpone_type_desc', class: 'text-xl-left body-1 black--text' },
        { text: '% Progress', align: 'left', value: 'pct_progress', class: 'text-xl-left body-1 black--text' },
        { text: 'remark', width: '1000', align: 'left', value: 'remark', class: 'text-xl-left body-1 black--text' },
        { text: 'date_created', align: 'left', value: 'date_created', class: 'text-xl-left body-1 black--text' },
        { text: 'user_created', align: 'left', value: 'user_created', class: 'text-xl-left body-1 black--text' },
        { text: 'date_changed', align: 'left', value: 'date_changed', class: 'text-xl-left body-1 black--text' },
        { text: 'user_changed', align: 'left', value: 'user_changed', class: 'text-xl-left body-1 black--text' },
      ]
    },
    headersAttribute () {
      return [
        { text: '#', align: 'center', value: 'data-table-no', class: 'text-xl-left body-1 black--text' },
        { text: '', align: 'center', value: 'data-table-select', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('actions'), value: 'actions', sortable: false, class: 'text-xl-left body-1 black--text' },
        { text: 'Attribute Name', align: 'left', value: 'attr_name', class: 'text-xl-left body-1 black--text' },
        { text: 'Attribute Desc', align: 'left', value: 'attr_desc', class: 'text-xl-left body-1 black--text' },
        { text: 'Value', width: '200', align: 'left', value: 'attr_value', class: 'text-xl-left body-1 black--text' },
        { text: 'Start Value', align: 'left', value: 'attr_start_value', class: 'text-xl-left body-1 black--text' },
        { text: 'End Value', align: 'left', value: 'attr_end_value', class: 'text-xl-left body-1 black--text' },
        { text: 'Nominal Value', align: 'left', value: 'nom_stk_value', class: 'text-xl-left body-1 black--text' },
        { text: 'Reference Code', align: 'left', value: 'ref_cd', class: 'text-xl-left body-1 black--text' },
      ]
    },
    offsetAppBar () {
      return this.getShowAppBar ? this.getAppBarHeight : 0
    }
  },

  watch: {
    'dialog.dialogAddEdit' (val) {
      val || this.close()
    },
    stateWindow: function (after, before) {
      try {
        switch (after) {
          case 'NewState':
            this.disabledControl.buttonNew = false
            this.disabledControl.buttonDelete = true
            this.disabledControl.buttonSave = false
            this.disabledControl.buttonQuery = false
            this.disabledControl.buttonFind = true
            this.readOnlyControl.textFieldResultItemID = true
            this.$refs.textFieldResultItemID.focus()
            break
          case 'DeleteState':
            this.disabledControl.buttonNew = false
            this.disabledControl.buttonDelete = true
            this.disabledControl.buttonSave = false
            this.disabledControl.buttonQuery = false
            this.disabledControl.buttonFind = true
            break
          case 'SaveState':
            this.disabledControl.buttonNew = false
            this.disabledControl.buttonDelete = false
            this.disabledControl.buttonSave = false
            this.disabledControl.buttonQuery = false
            this.disabledControl.buttonFind = false
            break
          case 'QueryState':
            this.disabledControl.buttonNew = false
            this.disabledControl.buttonDelete = true
            this.disabledControl.buttonSave = true
            this.disabledControl.buttonQuery = false
            this.disabledControl.buttonFind = false
            this.readOnlyControl.textFieldResultItemID = false
            this.$refs.textFieldResultItemID.focus()
            break
          case 'FindState':
            this.disabledControl.buttonNew = false
            this.disabledControl.buttonDelete = false
            this.disabledControl.buttonSave = false
            this.disabledControl.buttonQuery = false
            this.disabledControl.buttonFind = false
            this.readOnlyControl.textFieldResultItemID = true
            break
        }
      } catch (e) {
        this.$swal({type: 'error', title: e.message})
      }
    },
  },

  async created () {
    this.retrieveDropDown()
    if (localStorage.getItem('jobID') !== undefined && localStorage.getItem('jobID') !== null) {
      this.retrieveResultItem(localStorage.getItem('jobID'))
      localStorage.removeItem('jobID')
      this.stateWindow = 'FindState'
    } else {
      this.stateWindow = 'QueryState'
    }
  },

  mounted () {
  },

  updated () {
  },

  methods: {
    selectLanguage (language) {
    },
    getVarReturn (value) {
      switch (value.childSend) {
        case 'CustomerJobBrowse':
          this.dialog.dialogBrowseCustomer = false
          switch (value.actionReturn) {
            case 'OK':
              switch (value.browseName) {
                case 'browseCustomer':
                  this.jobData.cust_skey = value.dataSelected[0]['cust_skey']
                  this.jobData.cust_name = value.dataSelected[0]['cust_name']
                  break
              }
          }
          break
        case 'ProjectBrowse':
          this.dialog.dialogBrowseProject = false
          switch (value.actionReturn) {
            case 'OK':
              switch (value.browseName) {
                case 'browseProject':
                  this.jobData.proj_cd = value.dataSelected[0]['proj_cd']
                  this.jobData.proj_desc = value.dataSelected[0]['proj_desc']
                  break
              }
          }
          break
        case 'ResultItemBrowse':
          this.dialog.dialogBrowseResultItem = false
          switch (value.actionReturn) {
            case 'OK':
              switch (value.browseName) {
                case 'browseResultItem':
                  this.retrieveResultItem(value.dataSelected[0]['result_item_id'])
                  break
              }
          }
          break
        case 'CustomerIssueLogUserBrowse':
          switch (value.actionReturn) {
            case 'OK':
              switch (value.browseName) {
                case 'browsePersonInCharge':
                  this.jobData.person_in_charge = value.dataSelected[0]['user_id']
                  this.jobData.person_in_charge_name = value.dataSelected[0]['fullname']
                  this.dialog.dialogBrowsePersonInCharge = false
                  break
                case 'browseAssigner':
                  this.jobData.assigner = value.dataSelected[0]['user_id']
                  this.jobData.assigner_name = value.dataSelected[0]['fullname']
                  this.dialog.dialogBrowseAssigner = false
                  break
              }
              break
            default:
              switch (value.browseName) {
                case 'browsePersonInCharge':
                  this.dialog.dialogBrowsePersonInCharge = false
                  break
                case 'browseAssigner':
                  this.dialog.dialogBrowseAssigner = false
                  break
              }
          }
          break
        case 'IssueLogIDBrowse':
          switch (value.actionReturn) {
            case 'OK':
              switch (value.browseName) {
                case 'browseIssueLogID':
                  this.jobData.issue_log_id = value.dataSelected[0]['issue_log_id']
                  this.dialog.dialogBrowseIssueLogID = false
                  break
              }
              break
            default:
              switch (value.browseName) {
                case 'browseIssueLogID':
                  this.dialog.dialogBrowseIssueLogID = false
                  break
              }
          }
          break
      }
    },
    initialize () {
      this.vDataTable.selected = []
      this.vDataTable.editedIndex = -1
      this.vDataTable.editedItem = {
        win_name: '',
        window_comment: ''
      }
      this.vDataTable.defaultItem = {
        win_name: '',
        window_comment: ''
      }
    },
    openDialogCriteria () {
      this.dialog.dialogCriteria = true
    },
    browseCustomer () {
      this.dialog.dialogBrowseCustomer = true
      this.sendVar.singleSelect = true
      this.sendVar.browseName = 'browseCustomer'
      this.$refs.CustomerJobBrowse.retrieveCustomer()
    },
    browseCustomerCriteria () {
      this.dialog.dialogBrowseCustomer = true
      this.sendVar.singleSelect = true
      this.sendVar.browseName = 'browseCustomerCriteria'
      this.$refs.CustomerJobBrowse.retrieveCustomer()
    },
    browsePersonInCharge () {
      this.dialog.dialogBrowsePersonInCharge = true
      this.sendVar.singleSelect = true
      this.sendVar.browseName = 'browsePersonInCharge'
      this.$refs.CustomerIssueLogUserBrowse.retrieveUser()
    },
    browseProject () {
      this.dialog.dialogBrowseProject = true
      this.sendVar.singleSelect = true
      this.sendVar.browseName = 'browseProject'
      this.$refs.ProjectBrowse.retrieveProject()
    },
    browseAssigner () {
      this.dialog.dialogBrowseAssigner = true
      this.sendVar.singleSelect = true
      this.sendVar.browseName = 'browseAssigner'
      this.$refs.AssignerBrowse.retrieveUser()
    },
    clearAssigner () {
      this.jobData.assigner = ''
      this.jobData.assigner_name = ''
    },
    browseIssueLogID () {
      this.dialog.dialogBrowseIssueLogID = true
      this.sendVar.singleSelect = true
      this.sendVar.browseName = 'browseIssueLogID'
      this.$refs.IssueLogIDBrowse.retrieveIssueLogID()
    },
    clearIssueLogID () {
      this.jobData.issue_log_id = ''
    },
    clearCustomer () {
      this.jobData.cust_skey = -1
      this.jobData.cust_name = ''
    },
    clearCustomerCriteria () {
      this.jobData.custSkey = -1
      this.jobData.custName = ''
    },
    clearPersonInCharge () {
      this.jobData.person_in_charge = ''
      this.jobData.person_in_charge_name = ''
    },
    clearProject () {
      this.jobData.proj_cd = ''
      this.jobData.proj_desc = ''
    },
    clearAll () {
      this.criteria.requestDateFromTo = []
      this.criteria.createdDateFromTo = []
      this.criteria.status = ''
      this.criteria.custSkey = -1
      this.criteria.custName = ''
      this.criteria.personInCharge = ''
      this.criteria.personInChargeName = ''
    },
    changeStatus (e) {
      if (e === 'CO') {
        this.vDataTable.editedItem.complete_date = this.utils.getCurrentDateStr()
        this.vDataTable.editedItem.pct_progress = 100
      }
    },
    changePostponeType (e) {
      let foundArr = this.dropDownData.postpone_type.filter(x => x.code === e)
      if (foundArr.length > 0) {
        this.vDataTable.editedItem.postpone_type_desc = foundArr[0].description
      }
    },
    async newJob () {
      await this.retrieveResultItem('')
      this.stateWindow = 'NewState'
      this.readOnlyLabOrder = false
      this.jobData.status = 'OP'
      this.jobData.urgent = false
      this.jobData.person_in_charge = this.userID
      this.jobData.person_in_charge_name = this.userFullName
      this.jobData.assigner = this.userID
      this.jobData.assigner_name = this.userFullName
      this.jobData.assign_date = this.utils.getCurrentDateStr()
    },
    async deleteJob () {
      await this.axios.post(process.env.VUE_APP_API + '/job/deleteJob' + process.env.VUE_APP_DATABASE_TYPE, {
        job_id: this.jobData.job_id,
      })
        .then(async response => {
          if (response.data.isSuccess) {
            this.$swal({type: 'success', title: response.data.reasonText})
            await this.retrieveResultItem('')
            this.stateWindow = 'QueryState'
          } else {
            await this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(async e => {
          await this.$swal({type: 'error', title: e.message})
        })
    },
    async saveJob () {
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')
      await this.axios.post(process.env.VUE_APP_API + '/job/saveJob' + process.env.VUE_APP_DATABASE_TYPE, {
        job: this.jobData,
      })
        .then(async response => {
          if (response.data.isSuccess) {
            await this.retrieveResultItem(response.data.data.job_id)
            this.$swal({type: 'success', title: response.data.reasonText})
            this.readOnlyLabOrder = true
            var jobID = this.$refs.textFieldResultItemID.value
          } else {
            await this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(async e => {
          await this.$swal({type: 'error', title: e.message})
        })
      this.dialog.dialogProgress = false
      this.stateWindow = 'SaveState'
    },
    async queryJob () {
      await this.retrieveResultItem('')
      this.stateWindow = 'QueryState'
    },
    async findResultItem () {
      var resultItemID = this.$refs.textFieldResultItemID.value
      if (resultItemID === undefined || resultItemID.length === 0) {
        this.dialog.dialogBrowseResultItem = true
        this.sendVar.singleSelect = true
        this.sendVar.browseName = 'browseResultItem'
        this.$refs.ResultItemBrowse.retrieveResultItem()
        this.stateWindow = 'FindState'
      } else {
        await this.retrieveResultItem(resultItemID)
        this.stateWindow = 'FindState'
        if (this.$refs.textFieldResultItemID.value === undefined || this.$refs.textFieldResultItemID.value.length === 0) {
          var format = require('string-format')
          await this.$swal({type: 'error', title: format('Not Found Result Item ID ({})', resultItemID)})
        }
      }
    },
    newJobDetail () {
      // let timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
      // alert(new Date().toLocaleString('en-US', { timeZone: timeZone }))
      // this.vDataTable.editedItem.request_date = new Date().toJSON().slice(0, 10)
      // this.vDataTable.editedItem.request_date = this.utils.getCurrentDateStr()
      this.vDataTable.editedItem.job_detail_skey = -1
      this.vDataTable.editedItem.job_id = this.jobData.job_id
      this.vDataTable.editedItem.status = 'OP'
      this.vDataTable.editedItem.postpone_type = 'O'
      let foundArr = this.dropDownData.postpone_type.filter(x => x.code === 'O')
      if (foundArr.length > 0) {
        this.vDataTable.editedItem.postpone_type_desc = foundArr[0].description
      }

      if (this.jobData.job_id.length === 0) {
        this.$swal({type: 'error', title: 'กรุณาเลือก Job ก่อนจะเพิ่มข้อมูล'})
        this.disabledControl.buttonSaveDetail = true
      } else {
        this.disabledControl.buttonSaveDetail = false
      }
    },
    async retrieveResultItem (resultItemID) {
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')
      await this.axios.post(process.env.VUE_APP_API + '/resultItem/retrieveResultItem' + process.env.VUE_APP_DATABASE_TYPE, {
        'result_item_id': resultItemID,
      })
        .then(response => {
          if (response.data.isSuccess) {
            this.resultItemData = response.data.data[0]
            this.vDataTable.data = this.jobData.job_detail
            this.initialize()
            console.log(this.resultItemData)
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
      this.dialog.dialogProgress = false
      this.dialog.dialogCriteria = false
    },
    retrieveDropDown () {
      this.axios.post(process.env.VUE_APP_API + '/resultItem/retrieveDropDown' + process.env.VUE_APP_DATABASE_TYPE, {
      })
        .then(response => {
          if (response.data.isSuccess) {
            this.dropDownData = response.data.data[0]
            console.log(this.dropDownData)
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
    },
    async addCustomerIssueLog (data) {
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')
      await this.axios.post(process.env.VUE_APP_API + '/customerIssueLog/addCustomerIssueLog' + process.env.VUE_APP_DATABASE_TYPE, {
        data: data
      })
        .then(response => {
          if (response.data.isSuccess) {
            this.vDataTable.editedItem.issue_log_id = response.data.data.issue_log_id
            this.vDataTable.editedItem.date_created = response.data.data.date_created
            this.vDataTable.editedItem.user_created = response.data.data.user_created
            this.vDataTable.editedItem.date_changed = response.data.data.date_changed
            this.vDataTable.editedItem.user_changed = response.data.data.user_changed
            this.vDataTable.data.push(this.vDataTable.editedItem)
            this.close()
            this.$swal({type: 'success', title: response.data.reasonText})
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
      this.dialog.dialogProgress = false
    },
    async updateCustomerIssueLog (data) {
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')
      await this.axios.post(process.env.VUE_APP_API + '/customerIssueLog/updateCustomerIssueLog' + process.env.VUE_APP_DATABASE_TYPE, {
        data: data
      })
        .then(response => {
          if (response.data.isSuccess) {
            Object.assign(this.vDataTable.data[this.vDataTable.editedIndex], this.vDataTable.editedItem)
            this.vDataTable.data[this.vDataTable.editedIndex].date_changed = response.data.data.date_changed
            this.vDataTable.data[this.vDataTable.editedIndex].user_changed = response.data.data.user_changed
            this.close()
            this.$swal({type: 'success', title: response.data.reasonText})
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
      this.dialog.dialogProgress = false
    },
    checkDeleteselected () {
      if (this.vDataTable.selected.length > 0) {
        this.$swal({
          text: 'Are you sure you want to delete selected Job Detail?',
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.$t('yes'),
          cancelButtonText: this.$t('no')
        }).then((result) => {
          if (result) {
            this.deleteSelected()
          }
        })
      } else {
        this.$swal({type: 'warning', title: 'Please select Job Detail to delete'})
      }
    },
    async deleteSelected () {
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')

      var del = []

      await this.utils.asyncForEach(this.vDataTable.selected, async function (x) {
        this.progressMessage = this.stringFormat('Deleting Job Detail {}', x.job_detail_skey)
        var val = await this.deleteJobDetail(x)

        if (val !== undefined) {
          del.push(val)
        }
      }.bind(this))

      // del.forEach(x => {
      //   this.vDataTable.selected.splice(this.vDataTable.selected.indexOf(x), 1)
      // })

      for (const x in del) {
        this.vDataTable.selected.splice(this.vDataTable.selected.indexOf(x), 1)
      }

      this.dialog.dialogProgress = false
      // this.retrieveWindow(this.appName)
    },
    async deleteJobDetail (item) {
      try {
        this.dialog.dialogProgress = true
        this.progressMessage = this.$t('waiting')
        var jobDetailSkey = item.job_detail_skey
        var valRet
        await this.axios.post(process.env.VUE_APP_API + '/job/deleteJobDetail' + process.env.VUE_APP_DATABASE_TYPE, {
          job_detail_skey: jobDetailSkey
        })
          .then(async response => {
            if (response.data.isSuccess) {
              if (this.vDataTable.data.indexOf(item) >= 0) {
                this.vDataTable.data.splice(this.vDataTable.data.indexOf(item), 1)
              }
              this.$swal({type: 'success', title: response.data.reasonText})
              valRet = item
            } else {
              await this.$swal({type: 'error', title: response.data.reasonText})
            }
          })
          .catch(async e => {
            await this.$swal({type: 'error', title: e.message})
          })
        return valRet
      } catch (e) {
        await this.$swal({type: 'error', title: e.message})
      } finally {
        this.dialog.dialogProgress = false
      }
    },
    editItem (item) {
      this.vDataTable.editedIndex = this.vDataTable.data.indexOf(item)
      this.vDataTable.editedItem = Object.assign({}, item)
      this.dialog.dialogAddEdit = true
    },
    async deleteItemConfirm (item) {
      // this.vDataTable.editedIndex = this.vDataTable.data.indexOf(item)
      // this.vDataTable.editedItem = Object.assign({}, item)
      this.$swal({
        text: this.stringFormat('Are you sure want to delete Customer Job Detail Skey {0}?', item.job_detail_skey),
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('yes'),
        cancelButtonText: this.$t('no')
      }).then(async (result) => {
        if (result) {
          var val = await this.deleteJobDetail(item)
          if (val !== undefined) {
            if (this.vDataTable.selected.indexOf(item) >= 0) {
              this.vDataTable.selected.splice(this.vDataTable.selected.indexOf(item), 1)
            }
          }
        }
      })
    },
    close () {
      this.dialog.dialogAddEdit = false
      this.$nextTick(() => {
        this.vDataTable.editedItem = Object.assign({}, this.vDataTable.defaultItem)
        this.vDataTable.editedIndex = -1
      })
    },
    async save () {
      if (this.vDataTable.editedItem.start_date === undefined) {
        this.$swal({type: 'error', title: 'กรุณาใส่ Start Date'})
        return
      }
      if (this.vDataTable.editedItem.due_date === undefined) {
        this.$swal({type: 'error', title: 'กรุณาใส่ Due Date'})
        return
      }
      if (this.vDataTable.editedItem.status !== 'OP') {
        if (this.vDataTable.editedItem.complete_date === undefined) {
          this.$swal({type: 'error', title: 'กรุณาใส่ Complete Date'})
          return
        }
      }
      if (this.vDataTable.editedIndex > -1) {
        Object.assign(this.vDataTable.data[this.vDataTable.editedIndex], this.vDataTable.editedItem)
        this.close()
      } else {
        this.vDataTable.data.push(this.vDataTable.editedItem)
        this.close()
      }
    }
  },
}
</script>
<style scoped>
.sticky-table-footer td {
  font-weight: bold;
  position: sticky;
  bottom: 0;
  background-color: #f8f8f8;
  border-top: thin solid rgba(0,0,0,.12);
}
</style>